import util, {getStoreColors, getStoreFonts} from "../util";
import store from '../store';
import * as actions from '../actions';
import designService from "./designService";
import { initPageBars } from "../canvas/page";
import menuObject from "../canvas/menu-object";

export function initDesignInStore(design) {
  store.dispatch(actions.setDesignId(design.id));
  store.dispatch(actions.setDesignSize(getStoreFonts(util.sizes.find(current => current.key === design.size))));
  store.dispatch(actions.setDesign(design));
  store.dispatch(actions.setIsDesignLoading(false));
  store.dispatch(actions.updateDesignColors(getStoreColors(design)));
  store.dispatch(actions.updateDesignFonts(getStoreFonts(design)));

  if (design.hasChanges) {
    store.dispatch(actions.markAsModified());
  }

  designService.getDesignAccents(design.id).then(response => {
    store.dispatch(actions.updateElementAttribute('accents', response.data));

    initPageBars();
    menuObject.findMenuActiveIcons();
    menuObject.markConfigsUntranslatable();
    menuObject.convertMenuObjectPriceStyles();
    menuObject.addMenuObjectDefaultModifierStyles();
    if (!$('#design-cfg').attr('highlight-ids-converted')) {
      menuObject.convertMenuItemHighlightIds();
      $('#design-cfg').attr('highlight-ids-converted', true);
    }
    menuObject.rerenderForModifiers();
    menuObject.storeDeprecatedLayouts();
  });
}
